import { render, staticRenderFns } from "./remote.vue?vue&type=template&id=8c25130c"
import script from "./remote.vue?vue&type=script&lang=js"
export * from "./remote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports